export const LOGO_PATHS = [
  {
    d: "M86.3221 18.492H82.2821V33.3173H76.0833V18.492H72.0433V13.1766H76.0833V6.92307H82.2821V13.1766H86.3221V18.492Z",
    fill: "#111111",
  },
  {
    d: "M111.287 18.7388H105.334C105.125 17.4823 103.709 16.715 101.906 16.715C100.103 16.715 98.687 17.3791 98.687 18.2855C98.687 19.2952 100.036 19.7843 103.5 20.3452C109.489 21.2517 111.635 23.2396 111.635 26.7667C111.635 30.9534 107.271 33.5337 102.115 33.5337C96.9595 33.5337 92.8054 30.8816 92.5962 26.5917H98.549C98.7583 27.9155 100.281 28.7905 102.218 28.7905C104.155 28.7905 105.646 28.0591 105.646 27.1167C105.646 26.1744 104.261 25.5102 100.766 24.9897C95.9176 24.2582 92.7342 22.755 92.7342 18.6041C92.7342 14.4533 96.8526 12.1154 102.013 12.1154C107.173 12.1154 111.047 14.6956 111.292 18.7432L111.287 18.7388Z",
    fill: "#111111",
  },
  {
    d: "M124.187 33.5337C117.89 33.5337 113.365 29.0338 113.365 22.8245C113.365 16.6153 117.89 12.1154 124.187 12.1154C129.508 12.1154 133.514 15.5341 134.244 19.8949H127.982C127.495 18.4996 126.138 17.5215 124.192 17.5215C121.305 17.5215 119.425 19.7558 119.425 22.8245C119.425 25.8932 121.305 28.1275 124.192 28.1275C126.107 28.1275 127.53 27.1495 128.09 25.6869H134.351C133.308 30.429 129.338 33.5337 124.192 33.5337H124.187Z",
    fill: "#111111",
  },
  {
    d: "M135.649 23.3676C135.649 17.2198 139.702 12.7644 145.519 12.7644C148.187 12.7644 150.124 13.6973 151.336 15.3186V13.2442H157.5V33.4822H151.336V31.4122C150.124 33.0335 148.182 33.9664 145.519 33.9664C139.702 33.9664 135.649 29.511 135.649 23.3632V23.3676ZM151.438 23.3676C151.438 20.2582 149.501 18.0149 146.485 18.0149C143.47 18.0149 141.671 20.2582 141.671 23.3676C141.671 26.4771 143.541 28.7203 146.485 28.7203C149.429 28.7203 151.438 26.4771 151.438 23.3676Z",
    fill: "#111111",
  },
  {
    d: "M160.101 13.0339H166.305V15.1347C167.524 13.4928 169.407 12.5481 172.021 12.5481C176.759 12.5481 180 16.0119 180 21.6756V33.5336H173.796V22.7282C173.796 19.6152 172.541 17.9013 170.205 17.9013C167.869 17.9013 166.3 19.8267 166.3 23.0071V33.5336H160.096V13.0339H160.101Z",
    fill: "#111111",
  },
  {
    d: "M29.2067 25.0552V13.1971H35.411V24.0025C35.411 27.1155 36.6662 28.8295 39.0018 28.8295C41.3373 28.8295 42.9063 26.9041 42.9063 23.7236V13.1971H49.1106V33.6924H42.9063V31.596C41.687 33.238 39.8042 34.1827 37.1907 34.1827C32.4523 34.1827 29.2112 30.7188 29.2112 25.0552H29.2067Z",
    fill: "#111111",
  },
  {
    d: "M70.394 18.8882H64.3735C64.1618 17.6444 62.7299 16.8848 60.9061 16.8848C59.0824 16.8848 57.6505 17.5422 57.6505 18.4395C57.6505 19.439 59.0149 19.9232 62.5182 20.4784C68.5747 21.3757 70.7452 23.3435 70.7452 26.835C70.7452 30.9794 66.3323 33.5336 61.1178 33.5336C55.9033 33.5336 51.702 30.9084 51.4904 26.6618H57.5109C57.7225 27.9722 59.2626 28.8384 61.2214 28.8384C63.1802 28.8384 64.6887 28.1143 64.6887 27.1815C64.6887 26.2487 63.2882 25.5912 59.7534 25.0759C54.8496 24.3519 51.63 22.8638 51.63 18.7549C51.63 14.646 55.7953 12.3317 61.0142 12.3317C66.2332 12.3317 70.1508 14.8859 70.3985 18.8926L70.394 18.8882Z",
    fill: "#111111",
  },
  {
    d: "M4.79648 34.9612H0V45.171H10.2098V40.3745H4.79648V34.9612Z",
    fill: "#8F14E5",
  },
  {
    d: "M0 0V10.2098H4.79648V4.79648H10.2098V0H0Z",
    fill: "#8F14E5",
  },
  {
    d: "M20.4956 8.10427C20.4956 6.29833 21.8143 4.97516 23.6247 4.97516C25.4352 4.97516 26.7539 6.29386 26.7539 8.10427C26.7539 9.91469 25.4352 11.2334 23.6247 11.2334C21.8143 11.2334 20.4956 9.91469 20.4956 8.10427Z",
    fill: "#111111",
  },
  {
    d: "M20.8622 13.2181V27.8087C20.8622 30.6517 19.7134 32.2163 17.5722 32.2163C17.3442 32.2163 17.1252 32.1939 16.9151 32.1582V36.7803C17.6035 36.9904 18.3723 37.1066 19.2306 37.1066C23.5756 37.1066 26.5438 33.9418 26.5438 28.7698V13.2181H20.8577H20.8622Z",
    fill: "#111111",
  },
] as const;

export const FLOATING_BLOB_TRANSITION = {
  duration: 5,
  repeat: Infinity,
  ease: "easeInOut",
} as const;

export const LOGO_LAYOUT_TRANSITION = {
  type: "spring",
  stiffness: 190,
  damping: 34,
  mass: 1.05,
} as const;

export const SMILE_SIMULATION_ASPECT_RATIO = "3:4";
export const SMILE_SIMULATION_FRAME_ASPECT_RATIO = 3 / 4;
export const SMILE_SIMULATION_CAPTURE_WIDTH = 896;
export const SMILE_SIMULATION_CAPTURE_HEIGHT = 1200;
export const SMILE_SIMULATION_API_URL =
  "https://asia-northeast3-gloud-office-project.cloudfunctions.net/api/veneer/simulation";
export const SMILE_SIMULATION_PROGRESS_BASE_MS = 45000;
export const SMILE_SIMULATION_PROGRESS_TARGET = 80;
export const SMILE_SIMULATION_PROGRESS_SOFT_CAP = 97;
export const SMILE_SIMULATION_PROGRESS_FINISH_MIN_MS = 240;
export const SMILE_SIMULATION_PROGRESS_FINISH_MAX_MS = 720;
export const SMILE_SIMULATION_PROGRESS_INTERVAL_MS = 120;
export const SMILE_SIMULATION_PROGRESS_CIRCLE_RADIUS = 46;
export const SMILE_SIMULATION_PROGRESS_CIRCLE_CIRCUMFERENCE =
  2 * Math.PI * SMILE_SIMULATION_PROGRESS_CIRCLE_RADIUS;
